import { FC } from 'react';
import styled from 'styled-components';

import { COLORS } from '@/shared/constants/colors';
import { ButtonProps } from '@/shared/uikit/Button';

import { ButtonIw } from './ButtonIw';

export const ButtonIwText: FC<ButtonProps> = ({ children, style, ...props }) => {
  const btnStyle = {
    ...style,
    height: '44px',
    paddingInline: 0,
    fontSize: 14,
    background: 'transparent',
  };

  props.type = 'text';

  return (
    <Container style={btnStyle} {...props}>
      {children}
    </Container>
  );
};

const Container = styled(ButtonIw)`
  color: ${COLORS.systemSky200} !important;

  &:hover {
    color: ${COLORS.systemSky300} !important;
  }
`;
